<gstar-admin-prime-grid
  #grid
  [source]="source()"
  [headers]="headers"
  [query]="queryWritable()"
  [searchSetting]="searchSetting"
  [drawerSetting]="drawerSetting"
  [normalActionMenu]="actionMenu"
  (queryChange)="queryHandler($event)" />
